import { Controller } from "stimulus"
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

export default class extends Controller {
  static targets = ["phone", "email", "form", "secondaryPhone"]

  initialize() {
    // validations
    this.editContactForm = this.editContactForm();
    this.addModalEventListener()
    this.focusOnModal()
  }

  addModalEventListener() {
    let self = this;
    let editContactModal = document.getElementById('editContactModal')
    editContactModal.addEventListener('shown.bs.modal', function (event) {
      let button = event.relatedTarget
      let contactData = button.getAttribute('data-bs-edit-contact')
      let data = JSON.parse(contactData);
      let roles = data.contact_roles

      roles.filter((r) => r !== "team").forEach((role) => {
      document.getElementById(`editContactRoles-${role}`).checked = true;
      })
      document.querySelectorAll('[id^=editContactRoles-]').forEach((el) => {
        document.getElementById(el.id).value = el.id.split("-").pop();
      })
      document.getElementById('editContactName').value = data.name
      document.getElementById('editContactPreferredName').value = data.preferred
      document.getElementById('editContactReference').value = data.ref
      document.getElementById('editContactEmail').value = data.email
      document.getElementById('editContactEmail').disabled = roles.includes("team") ? true : false
      document.getElementById('editContactPhone').value = data.phone
      document.getElementById('editContactSecondaryPhone').value = data.secondary_phone
      document.getElementById('editContactNotes').value = data.notes
      let ecd = document.getElementById('editContactEmergencyContactDetails')
      if (ecd) ecd.value = data.emergency_contact_details
      document.getElementById('editDialoutAutoJoin').checked = data.dialout_auto_join
      let smsCheckbox = document.getElementById('editSmsRemindersEnabled')
      if (smsCheckbox) smsCheckbox.checked = data.sms_reminders_enabled
      document.getElementById('editContactForm').action = 'contacts/' + data.id.toString()
    })
    editContactModal.addEventListener('hidden.bs.modal', function (event) {
      document.querySelectorAll('[id^=editContactRoles-]').forEach((el) => el.checked = false)
      self.editContactForm.resetForm(true);
    })
  }

  focusOnModal() {
    //focuses on modal when it is shown
    //required for screen readers
    var modal = document.getElementById('editContactModal');
    modal.addEventListener('shown.bs.modal', function() {
      var firstInput = this.querySelector('#editContactForm input.form-control');
      if (firstInput) {
          firstInput.focus();
      }
  });
  }

  submitContactForm() {
    document.getElementById("editContactSubmit").disabled = true;
    this.editContactForm.validate().then(function (status) {
      if (status == 'Valid') {
        document.getElementById("editContactForm").submit();
      } else {
        document.getElementById("editContactSubmit").disabled = false;
      }
    });
  }

  phoneOrEmailPresent() {
    return this.phoneTarget.value?.length > 0;
  }

  editContactForm() {
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('editContactForm'),
      {
        fields: {
          contactName: {
            selector: '[name="contact_form[name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Full name is required'
              },
              stringLength: {
                max: 255,
                message: 'Full name must be less than 255 characters'
              }
            }
          },
          contactPreferredName: {
            selector: '[name="contact_form[preferred_name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Preferred name is required'
              },
              stringLength: {
                max: 255,
                message: 'Preferred name must be less than 255 characters'
              }
            }
          },
          reference: {
            selector: '[name="contact_form[reference]"]',
            validators: {
              stringLength: {
                max: 255,
                message: 'Reference must be less than 255 characters'
              }
            }
          },
          phone: {
            selector: '[name="contact_form[phone]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Phone number is required'
              },
              checkValidNumber: {
                message: 'Please enter a valid phone number',
                callback: function (input) {
                  return input.value.length == 0 || isValidPhoneNumber(input.value, 'GB')
                }
              },
              emailOrPhonePresent: {
                message: 'Phone must be present if no email provided',
                callback: function () {
                  return self.phoneOrEmailPresent()
                }
              }
            }
          },
          secondaryPhone: {
            selector: '[name="contact_form[secondary_phone]"]',
            validators: {
              checkValidNumber: {
                message: 'Please enter a valid number',
                callback: function (input) {
                  return input.value.length == 0 || isValidPhoneNumber(input.value, 'GB')
                }
              }
            }
          },
          contactRoles: {
            selector: '[name="contact_form[contact_roles][]"]',
            validators: {
              choice: {
                min: 1,
                message: 'Please select at least one role for this contact'
              }
            }
          },
          notes: {
            selector: '[name="contact_form[notes]"]',
            validators: {
              stringLength: {
                max: 30000,
                message: 'Notes must be less than 30,000 characters'
              }
            }
          },
          emergency_contact_details: {
            selector: '[name="contact_form[emergency_contact_details]"]',
            validators: {
              stringLength: {
                max: 256,
                message: 'Emergency contact details must be less than 256 characters'
              }
            }
          }
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger(),
          bootstrap5: new Bootstrap5({
            rowSelector: '.g-5'
          }),
          alias: new FormValidation.plugins.Alias({
            checkValidNumber: 'callback',
            emailOrPhonePresent: 'callback'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
          trigger: new FormValidation.plugins.Trigger(
            {
              event: 'input',
              threshold: 1,
              delay: 1

            }
          ),
        },
      }
    )
  }

}